<div class="full-page w-100 bg-primary">
  <div class="login-page">
    <img alt="" class="card-logo" src="assets/images/login-registration/login-logo.svg" draggable="false" />
    <div class="login-page-details-div text-center">
      <!-- Login Form -->
      <div class="icon material-icons maintenance-page-icon" aria-hidden="true">engineering</div>
      <h5 class="maintenance-page-heading text-heading mb-0">{{ 'maintenancepage.currentlyunavailable.text' | translate }}</h5>
      <p
        class="font-size-14 text-default mb-0"
        [innerHTML]="'maintenancepage.currentlyunavailable.subheading' | translate | markdownTranslate"
      ></p>
    </div>
  </div>
</div>
